import React, { Component } from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router"
import PropTypes from "prop-types"
import Documents from "./Documents"
class index extends Component {
  componentDidMount() {}
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>{this.props.t("Documents administratif")} | Cresus</title>
          </MetaTags>
          <Container fluid>
            <Documents />
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
index.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
}
export default withRouter(withTranslation()(index))
